<template>
  <div :style="iconStyle" v-html="iconContent" v-if="!showImg"></div>
  <img v-else :src="iconSrc" :style="getIconImgStyle" />
</template>

<script>
export default {
  name: "cxIcon",
  props: {
    options: {
      type: Object,
      required: true
    },
    iconStyle: {
      type: Object,
      required: true
    },
    iconSrcType: {
      type: Number,
      required: false
    },
    iconSrcName: {
      type: String,
      default: "iconSrc"
    },
    imgType: {
      type: String,
      default: ""
    },
    iconSrcDefault: {
      type: String,
      required: false
    },
  },
  data() {
    return {
      showImg: false
    }
  },
  computed: {
    iconSrc() {
      let iconSrc
      let iconSrcType = Number(this.options.iconSrcType)
      switch (iconSrcType) {
        case 0:
          // iconSrc = this.options.iconSrc
          iconSrc = this.options[this.iconSrcName]
          break
        case 1:
          iconSrc = this.options.hoverIsSameActive ? this.options.clickIconSrc : this.options.hoverIconSrc
          break
        case 2:
          iconSrc = this.options.clickIconSrc
          break
        // case 3:
        //   iconSrc = this.options.iconSrc1
        //   break
        // case 4:
        //   iconSrc = this.options.iconSrc2
        //   break
        default:
          // iconSrc = this.options.iconSrc
          iconSrc = this.options[this.iconSrcName]
      }
      if(this.iconSrcDefault){
        iconSrc = this.iconSrcDefault
      }
      return iconSrc
    },
    iconContent() {
      if (!this.iconSrc) {
        return ""
      }
      let svgContent = this.$store.state.states.iconSvg
      if (this.iconSrc && svgContent && svgContent.hasOwnProperty(this.iconSrc)) {
        return svgContent[this.iconSrc]
      }
      if (!svgContent || !svgContent.hasOwnProperty(`${this.iconSrc}`)) {
        this.$store.commit("states/updateSvg", {
          svgId: this.iconSrc,
          value: " "
        })
        this.getSvgContent(this.iconSrc)
      }
    },
    getMargin() {
      return this.options.iconPosition === "left"
        ? `0 ${this.options.iconMargin}px 0 0`
        : this.options.iconPosition === "right"
        ? `0 0 0 ${this.options.iconMargin}px`
        : this.options.iconPosition === "top"
        ? `0 0 ${this.options.iconMargin}px 0`
        : `${this.options.iconMargin}px 0 0 0`
    },
    getIconImgStyle() {
      if (this.options.innerElement === "cxButton" || this.options.innerElement === "cxLabel") {
        return {
          width: this.options.iconWidth + "px",
          margin: this.getMargin
        }
      } else if (this.imgType === "anchorBtn") {// 锚点按钮
        return {
          ...this.iconStyle
        }
      }
      return {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100%",
        padding: "8px"
      }
    }
    // getIconImgStyle() {
    //   return {
    //     position: "absolute",
    //     top: "50%",
    //     left: "50%",
    //     transform: "translate(-50%,-50%)",
    //     // width: this.options.iconWidth + "px",
    //     // width: "100%",
    //     height: "100%",
    //     padding: "8px"
    //   }
    // }
  },
  components: {},
  mounted() {},
  watch: {
    iconSrc: {
      immediate: true,
      handler: function (n, o) {
        if (!n) {
          return
        }
        if (this.iconSrc.indexOf("png") > -1 || this.iconSrc.indexOf("jpg") > -1 || this.iconSrc.indexOf("jpeg") > -1  || this.iconSrc.indexOf("gif") > -1 || this.iconSrc.indexOf("file/download") > -1) {
          this.showImg = true
          return
        }
        this.showImg = false
      }
    }
  },
  methods: {
    getSvgContent(iconSrc) {
      this.$API
        .querySvg({
          publicId: iconSrc
        })
        .then(res => {
          if (res?.status !== 200) return
          this.$store.commit("states/updateSvg", {
            svgId: iconSrc,
            value: res.data
          })
        })
    }
  }
}
</script>

<style scoped>
::v-deep svg * {
  stroke: var(--color);
}
::v-deep svg {
  vertical-align: top;
  width: 100%;
  height: 100%;
}
</style>
